module.exports = __webpack_public_path__ + "img/dados-titular.4100c9f8.png";